module.exports = __webpack_public_path__ + "img/2.2f30a2b0.png";